import { useEffect, useState } from "react";

const KEY = "bs_attribution";
const FIELDS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid"];

export default function useAttribution() {
  const [attribution, setAttribution] = useState({});

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const stored = JSON.parse(sessionStorage.getItem(KEY) || "{}");
    const fresh = {};
    FIELDS.forEach((f) => {
      const v = params.get(f);
      if (v) fresh[f] = v;
    });
    const merged = {
      ...stored,
      ...fresh,
      landing_page: window.location.pathname + window.location.search,
      referrer: document.referrer || "direct",
      device: window.innerWidth < 768 ? "mobile" : "desktop",
    };
    sessionStorage.setItem(KEY, JSON.stringify(merged));
    setAttribution(merged);
  }, []);

  return attribution;
}
